import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ProficiencyLegendDialogComponent } from "../../../shared/components/proficiency-legend-dialog/proficiency-legend-dialog.component";

@Component({
  standalone: false,
  selector: "app-proficiency-legend",
  templateUrl: "./proficiency-legend.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["./proficiency-legend.component.scss"],
})
export class ProficiencyLegendComponent {
  @Input() labelName = "Proficiency legend";

  constructor(private dialog: MatDialog) {}

  openProficiencyLegendDialog(): void {
    this.dialog.open(ProficiencyLegendDialogComponent, {
      width: "500px",
    });
  }
}
